export default __webpack_public_path__ + "d2ca9e5edd3af00fb7ec9d8944132ac6.svg";